// Función de ayuda para convertir grados a radianes
export const deg2rad = (degrees) => {
    return degrees * Math.PI / 180;
}
